/**
 * DashboardHeader - Header component for student dashboard
 */
import { Button } from '@/components/ui/button';
import { LogOut, Menu, X } from 'lucide-react';

const DashboardHeader = ({ onLogout, mobileMenuOpen, setMobileMenuOpen }) => {
  return (
    <header className="bg-white shadow-sm border-b sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
        <div className="flex justify-between items-center gap-2">
          <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
            {/* Mobile menu button */}
            <button 
              className="lg:hidden p-1.5 sm:p-2 hover:bg-gray-100 rounded-lg flex-shrink-0"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
            
            <img 
              src="https://customer-assets.emergentagent.com/job_cgda-exam-prep/artifacts/bek6ttpm_logo.png" 
              alt="Departmental Exam"
              className="h-10 sm:h-14 md:h-16 object-contain max-w-[180px] sm:max-w-none"
            />
          </div>
          <Button onClick={onLogout} variant="outline" size="sm" className="text-xs px-2 sm:px-3 flex-shrink-0" data-testid="logout-btn">
            <LogOut className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
            <span className="hidden xs:inline">Logout</span>
            <span className="xs:hidden">Exit</span>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
